import { useEffect, useRef, useState } from "react";
import { HomePageSC, HomeToolbarSC } from "./homepage.styles";
import Testimonials from "./testimonials/testimonials";
import FAQHolder from "./faqs/faqs";
import Metrics from "./metrics/metrics";
import WhatsappAction from "./whatsapp/whatsapp_action";
import CategoryGrid from "./category/categories";
import MeetCounselor from "./intro/meet_counselor.component";
import MemorableMoments from "./memorable_moments/memorable_moments";
import Instagram from "../../assets/instagram.svg";
import Facebook from "../../assets/facebook.svg";
import Youtube from "../../assets/youtube.svg";
import Linkedin from "../../assets/linkedin.svg";
import LocationIcon from "../../assets/location_icon.svg";
import EmergencyContact from "./emergency_contact/emergency_contact";
import GroupInviteBanner from "./group_invite/group_invite.component";
import Donations from "./donations/donations";
import Hero from "./hero/hero.component";
import SideNav from "./sidenav/sidenav";
import HambergMenu from '../../assets/hamburg_menu.svg';
import Logo from '../../assets/logo512.png';


const Toolbar = ({ onChange }) => {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const handleKey = (e) => {
            if (e.key === "Escape")
                setVisible(false);
        };

        window.addEventListener("keydown", handleKey);
        return () => window.removeEventListener("keydown", handleKey);
    }, []);

    const isMobile = window.screen.width < 800;
    const onMenuClick = () => {
        setVisible(!visible);
    }

    return <HomeToolbarSC>
        <div className="brand-name">
            <img src={Logo} alt="Logo" className="logo" />
            <span>Niraatanka</span>
        </div>
        {
            isMobile ? <div /> : <div className="navigation">
                <span onClick={() => onChange('YourCounselor')}>Your Counselor</span>
                <span onClick={() => onChange('Testimonials')}>Testimonials</span>
                <span onClick={() => onChange('FAQ')}>FAQ</span>
                <span className="emergency" onClick={() => onChange('EmergencyContact')}>Emergency Contact</span>
            </div>
        }
        {
            isMobile ? <div /> : <WhatsappAction showNumber={true} />
        }

        {
            isMobile ? <div className="side-nav-icon" onClick={onMenuClick}>
                <img src={HambergMenu} alt="Menu" />
            </div> : null
        }
        {
            isMobile && visible ? <SideNav onSelect={(option) => {
                setVisible(false);
                onChange(option);
            }} visible={visible} setVisible={setVisible} /> : null
        }

    </HomeToolbarSC>
}

const HomePage = () => {
    const testimonialsRef = useRef(null);
    const faqRef = useRef(null);
    const emergencyRef = useRef(null);
    const yourConselorRef = useRef(null);
    const memorableMomentsRef = useRef(null);
    const communityContributionsRef = useRef(null);
    const peerGroupRef = useRef(null);

    const handleMenuSelect = (option) => {
        console.log("Selected:", option);
    };
    const scrollToSection = (ref) => {
        ref.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    };

    function handleScroll(text) {
        switch (text) {
            case "Testimonials":
                scrollToSection(testimonialsRef);
                break;
            case "FAQ":
                scrollToSection(faqRef);
                break;
            case "EmergencyContact":
                scrollToSection(emergencyRef);
                break;
            case "YourCounselor":
                scrollToSection(yourConselorRef);
                break;
            case "MemorableMoments":
                scrollToSection(memorableMomentsRef);
                break;
            case "CommunityContributions":
                scrollToSection(communityContributionsRef);
                break;
            case "PeerGroup":
                scrollToSection(peerGroupRef);
                break;
        }
    }

    return <HomePageSC>
        <Toolbar onChange={handleScroll} handleMenuSelect={handleMenuSelect} />
        <Hero />
        <CategoryGrid />
        <MeetCounselor ref={yourConselorRef} />
        <Metrics />
        <div style={{ height: "56px" }} />
        <WhatsappAction />
        <Testimonials ref={testimonialsRef} />
        <MemorableMoments ref={memorableMomentsRef} />
        <Donations ref={communityContributionsRef} />
        <div style={{ height: "24px" }} />
        <WhatsappAction />
        <GroupInviteBanner ref={peerGroupRef} />
        <FAQHolder ref={faqRef} />
        <div style={{ height: "56px" }} />
        <WhatsappAction />
        <EmergencyContact ref={emergencyRef} />
        <HomeFooter />
    </HomePageSC>
}

const HomeFooter = () => {
    return <div className="home-footer-container">
        <div className="home-footer">
            copyright © Niraatanka. 2026. All rights reserved.
        </div>
        <div style={{ display: "flex", justifyContent: "center", gap: "16px", marginBottom: "24px" }}>
            <img src={Instagram} className="social-icon" alt="Instagram"
                onClick={() => window.open("https://www.instagram.com/niraatankacounselingc/", "_blank")} />
            <img src={Youtube} className="social-icon" alt="Youtube"
                onClick={() => window.open("https://www.youtube.com/@NiraatankaCounselingCenter", "_blank")} />
            <img src={Linkedin} className="social-icon" alt="Linkedin"
                onClick={() => window.open("https://www.linkedin.com/company/niraatanka-counselling-centre", "_blank")} />
            <img src={Facebook} className="social-icon big" alt="Facebook"
                onClick={() => window.open("https://www.facebook.com/Niraatanka", "_blank")} />
            <img src={LocationIcon} className="social-icon big" alt="Location"
                onClick={() => window.open("https://maps.app.goo.gl/KM38s9NsZZUb6DP96", "_blank")} />
        </div>
    </div >
}

export default HomePage;